<template>
  <div class="special-case-step col-lg-10">
    <section class="step-group">
      <h3>{{ $t("common.notes") }}</h3>
      <DxTextArea :value="notes" :height="180" :disabled="saving" @value-changed="setNotes($event.value)" />
    </section>
  </div>
</template>

<script>
import DxTextArea from "devextreme-vue/text-area";

export default {
  name: "SpecialCaseNotesStep",
  components: { DxTextArea },
  props: {
    formData: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  data() {
    return { notes: this.formData.notes || "" };
  },
  watch: {
    "formData.notes"(value) {
      this.notes = value || "";
    },
  },
  methods: {
    setNotes(value) {
      this.notes = value || "";
      this.$emit("input", { notes: this.notes });
    },
    validate() {
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.special-case-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.step-group {
  padding-bottom: 18px;
  border-bottom: 1px solid #dedede;
}
.step-group h3 {
  margin: 0 0 12px;
  font-size: 17px;
}
</style>